// extracted by mini-css-extract-plugin
module.exports = {"sisterContainer":"sister_property_section_sisterContainer__3sO6B","sisterImage":"sister_property_section_sisterImage__2v1TK"};